import CookieConsents, {
  CONSENT_LIFETIME_SECONDS,
} from 'utils/cookieConsents'


export default function isCookieConsentExpired() {
  return !CookieConsents.getConsents(CONSENT_LIFETIME_SECONDS)
}
